import { cn } from '../../utils/cn'

// cards: array de { tag, tagColor, title, text, solution }
// solution: { product, text }
export default function ProblemCards({
  intro = 'Quais problemas que a gente resolve?',
  lead,
  summary,
  cards = [],
  solutionBoxClass = 'border-[#C0DBBD] bg-[#F2FFF4]',
  solutionLabelClass = 'text-[#517B44]',
}) {
  return (
    <div className="w-full px-20 pb-8">
      {intro && (
        <h2 className="mb-6 font-inter-extrabold text-2xl text-[#454545]">
          {intro}
        </h2>
      )}

      {lead && (
        <p className="mb-6 font-inter-regular text-base leading-relaxed text-[#333333]">
          {lead}
        </p>
      )}

      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        {cards.map((card, index) => (
          <div
            key={index}
            className="flex flex-col gap-6 rounded-[10px] border border-[#E0E0E0] p-6"
          >
            <span
              className="self-start rounded-full px-3 py-1 font-inter-semibold text-[14px] uppercase tracking-wide"
              style={{
                color: card.tagColor || '#FF4D1C',
                backgroundColor: `${card.tagColor || '#FF4D1C'}1A`,
              }}
            >
              {card.tag}
            </span>

            <h3 className="font-inter-semibold text-base text-[#454545]">
              {card.title}
            </h3>

            <p className="font-inter-regular text-sm leading-relaxed text-[#4A5565]">
              {card.text}
            </p>

            {card.solution && (
              <div
                className={cn(
                  'mt-2 flex flex-col gap-3 rounded-[8px] border p-6',
                  solutionBoxClass,
                )}
              >
                <span
                  className={cn(
                    'font-inter-semibold text-[14px] uppercase tracking-[0.15em]',
                    solutionLabelClass,
                  )}
                >
                  SOLUÇÃO
                </span>
                <span className="font-inter-semibold text-base text-[#454545]">
                  {card.solution.product}
                </span>
                <p className="font-inter-regular text-sm leading-relaxed text-[#454545]">
                  {card.solution.text}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>

      {summary && (
        <p className="mt-6 font-inter-regular text-base leading-relaxed text-[#333333]">
          {summary}
        </p>
      )}
    </div>
  )
}
